// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7882a2c4","709":"cf53713b","926":"aef56421"}[chunkId] + ".chunk.js";
};